import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	incompatibleFieldMessageNoOptionToSwitchToOldModal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	incompatibleFieldMessageNoOptionToSwitchToOldModal: {
		id: 'issue-create.common.fields.incompatible-field.incompatible-field-message-no-option-to-switch-to-old-modal',
		defaultMessage: 'The <b>{fieldName}</b> field is not supported on this screen.',
		description: 'Inline message for incompatible fields',
	},
});
export default messages;
